"use client";

import Image from "next/image";
import Link from "next/link";

import { FileProps } from "@/types";

import api from "@/lib/api";

export default function GettingStarted() {
  const handlePDFClick = async () => {
    try {
      const response = await api.get<FileProps>("/files/emjuzdwh/");

      const pdfUrl = response.url;

      if (pdfUrl) {
        window.open(pdfUrl, "_blank");
      } else {
        alert("PDF not found");
      }
    } catch (error: any) {
      console.error("Error fetching PDF:", error);
      alert("Failed to fetch PDF link. Please try again later.");
    }
  };

  return (
    <>
      <p className="g2-text-grey">
        First time using the Gateway? Find out more about all the features of the Gateway and see our brochure on HCAP
        data. <br />
        <b>The Gateway to Global Aging HCAP Data</b> provides extensive information about the HCAP interviews conducted
        by the network of Health and Retirement Studies.
      </p>
      <h4 className="g2-header-navy">The Gateway Features</h4>
      <hr />
      <p className="g2-text-grey">
        <Link href="/hcap-studies/overview" className="fw-bold g2-link-blue">
          STUDY OVERVIEWS
        </Link>{" "}
        Learn about each study with an HCAP interview in the International Network of Health and Retirement Studies
      </p>
      <p className="g2-text-grey">
        <Link href="/hcap-studies/questionnaire" className="fw-bold g2-link-blue">
          SURVEY QUESTIONNAIRES
        </Link>{" "}
        View HCAP survey questionnaires from each wave (interview year) of each study
      </p>
      <p className="g2-text-grey">
        <Link href="/hcap-studies/search" className="fw-bold g2-link-blue">
          QUESTIONNAIRE SEARCH
        </Link>{" "}
        Search for relevant survey questions from all studies by keyword
      </p>

      <p className="g2-text-grey">
        <Link href="/hcap-studies/get-data" className="fw-bold g2-link-blue">
          GET SURVEY DATA
        </Link>{" "}
        Get access to HCAP data
      </p>
      <p className="g2-text-grey">
        <Link href="/harmonized-hcap-data/overview" className="fw-bold g2-link-blue">
          HARMONIZED DATA OVERVIEWS
        </Link>{" "}
        Get information about each of our Harmonized HCAP datasets
      </p>
      <p className="g2-text-grey">
        <Link href="/harmonized-hcap-data/variable-concordance" className="fw-bold g2-link-blue">
          HARMONIZED VARIABLE CONCORDANCE
        </Link>{" "}
        Find and compare Harmonized HCAP variables by topic
      </p>
      <p className="g2-text-grey">
        <Link href="/harmonized-hcap-data/get-data" className="fw-bold g2-link-blue">
          GET HARMONIZED DATA
        </Link>{" "}
        Get access to Harmonized HCAP data
      </p>
      <p className="g2-text-grey">
        <Link href="/additional-hcap-resources/publications" className="fw-bold g2-link-blue">
          PUBLICATIONS
        </Link>{" "}
        Find topic and study-specific HCAP publications
      </p>
      <p className="g2-text-grey">
        <Link href="/additional-hcap-resources/webinars-and-presentations" className="fw-bold g2-link-blue">
          WEBINARS AND PRESENTATIONS
        </Link>{" "}
        Watch recent HCAP presentations or webinars
      </p>
      <p className="g2-text-grey">
        <a href="mailto:help@g2aging.org" className="fw-bold g2-link-blue" target="_blank">
          HELP DESK
        </a>{" "}
        Email any questions you might have!
      </p>

      <h4 className="g2-header-navy mt-5">GATEWAY HCAP Brochure</h4>
      <hr />
      <p>
        <Image
          alt="HCAP Brochure"
          width="300"
          height="350"
          src="/hcap_brochure.png"
          onClick={handlePDFClick}
          style={{
            border: "1px solid #bbb9b5",
            cursor: "pointer",
          }}
        />
      </p>

      <h4 className="g2-header-navy">Other Links For Getting Started</h4>
      <hr />
      <p className="g2-text-grey">
        <Link href="/help/faqs" className="fw-bold g2-link-blue">
          FREQUENTLY ASKED QUESTIONS
        </Link>{" "}
        See answers to frequently asked questions by Gateway users
      </p>
      <p className="g2-text-grey">
        <Link href="/help/tutorials" className="fw-bold g2-link-blue">
          TUTORIALS
        </Link>{" "}
        Find tutorials on a variety of topics including using the Gateway and utilizing Harmonized data
      </p>
    </>
  );
}
